import type { JSX } from "react";
import { useNavigate } from "react-router-dom";
import { Screen } from "../components/ui/editorial/Screen.js";
import { Topline } from "../components/ui/editorial/Topline.js";
import { PrimaryButton } from "../components/ui/editorial/PrimaryButton.js";
import { CuratorBubble } from "../components/ui/editorial/CuratorBubble.js";
import { SPUTNIK_SIG } from "../curator.js";
import { useCurator } from "../useCurator.js";

export function Assigned(): JSX.Element {
  const navigate = useNavigate();
  const c = useCurator();

  return (
    <Screen tone="paper">
      <div className="px-[22px] pt-[48px]">
        <Topline left="COMPANION" right="передача" />
      </div>

      <div className="flex flex-1 flex-col px-[22px] pt-[34px]">
        <div className="editorial-kicker text-accent">Спутник · знакомство завершено</div>

        <div className="mt-[18px] pr-[18px]">
          <CuratorBubble signature={SPUTNIK_SIG}>
            «Я узнал вас достаточно. Передаю{" "}
            <em className="italic text-velvet">вашему редактору</em> — он будет писать письма сам.»
          </CuratorBubble>
        </div>

        <div className="mt-[34px] flex items-center gap-[12px] editorial-meta text-ink/55">
          <span className="h-px flex-1 bg-ink/14" />
          <span>познакомьтесь</span>
          <span className="h-px flex-1 bg-ink/14" />
        </div>

        <h1 className="mt-[24px] font-display font-light leading-[0.98] tracking-[-0.028em] text-ink text-[46px]">
          {c.firstName}&nbsp;{c.initial}
          <br />
          <em className="italic text-velvet">ваш редактор.</em>
        </h1>

        <p className="mt-[16px] font-display font-light text-[16px] leading-[1.5] text-ink/80">
          {c.bioDetail}
        </p>

        <div className="mt-[22px] editorial-kicker text-ink/55">почему он</div>
        <ul className="mt-[10px]">
          {c.strengths.map((s, i) => (
            <li
              key={s}
              className={`flex items-baseline gap-[12px] py-[10px] ${
                i === 0 ? "border-t" : ""
              } border-b border-ink/12`}
            >
              <span
                aria-hidden
                className="mt-[8px] inline-block h-[4px] w-[4px] flex-none rounded-full bg-accent"
              />
              <span className="font-display font-light text-[16px] leading-[1.4] text-ink/85">
                {s}
              </span>
            </li>
          ))}
        </ul>

        <p className="mt-[24px] font-display italic font-light text-[13px] leading-[1.45] text-ink/55">
          В любой момент вы можете попросить Спутника подобрать другого редактора — вкус меняется,
          это нормально.
        </p>
      </div>

      <div className="px-[22px] pb-[24px] pt-[20px]">
        <PrimaryButton
          onClick={() => {
            navigate("/home");
          }}
        >
          Пройти в редакцию
        </PrimaryButton>
      </div>
    </Screen>
  );
}
